import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import { Button } from 'primereact/button';
import {
  updateChain as _updateChain,
} from '../../../actions/chainActions';
import { getLengthValidator } from '../../../utils/validators';
import { T, cardStyle, inputStyle, inputLabelStyle } from './chainSettingsV2Styles';

class SettingsChainInfoV2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        name: '',
        business_id: '',
        street_address: '',
        zip_code: '',
        city: '',
        phone_number: '',
        email: '',
      },
      formValid: {},
      hasChanges: false,
    };
  }

  componentDidMount() {
    this.initializeForm();
  }

  componentDidUpdate(prevProps) {
    if (this.props.chain && (!prevProps.chain || prevProps.chain.id !== this.props.chain.id)) {
      this.initializeForm();
    }
  }

  initializeForm = () => {
    var chain = this.props.chain;
    if (chain) {
      this.setState({
        formData: {
          name: chain.name || '',
          business_id: chain.business_id || '',
          street_address: chain.street_address || '',
          zip_code: chain.zip_code || '',
          city: chain.city || '',
          phone_number: chain.phone_number || '',
          email: chain.email || '',
        },
        hasChanges: false,
      });
    }
  };

  setIsValid = (name, isValid) => {
    var formValid = this.state.formValid;
    this.setState({
      formValid: { ...formValid, [name]: isValid },
    });
  };

  updateFormState = (changedObject) => {
    var formData = this.state.formData;
    this.setState({
      formData: { ...formData, [changedObject.target]: changedObject.value },
      hasChanges: true,
    });
  };

  submitForm = () => {
    var formData = this.state.formData;
    var chain = this.props.chain;
    var updateChain = this.props.updateChain;

    if (chain) {
      updateChain(chain.id, formData);
      this.setState({ hasChanges: false });
    }
  };

  render() {
    var t = this.props.t;
    var chain = this.props.chain;
    var chainStatus = this.props.chainStatus;
    var userRole = this.props.userRole;
    var canEdit = userRole === 'admin' || userRole === 'manager';
    var formData = this.state.formData;
    var hasChanges = this.state.hasChanges;

    var isLoading = chainStatus && chainStatus.loading;

    if (!chain) {
      return (
        <div style={{ ...cardStyle, position: 'relative', minHeight: 200 }}>
          <CBSpinnerFloating color={T.accent} />
        </div>
      );
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'card')}>
            <div style={getStyle(screenSize, styles, 'header')}>
              <div style={getStyle(screenSize, styles, 'iconBox')}>
                <i className="pi pi-building" style={{ fontSize: 20, color: T.accent }} />
              </div>
              <div>
                <h2 style={getStyle(screenSize, styles, 'title')}>{t('chainInfoTitle')}</h2>
                <p style={getStyle(screenSize, styles, 'description')}>{t('chainInfoDescription')}</p>
              </div>
            </div>

            {isLoading && <CBSpinnerFloating color={T.accent} />}

            <div style={getStyle(screenSize, styles, 'formContainer')}>
              <CBInputField
                name="name"
                inputStyle={inputStyle}
                value={formData.name}
                placeholder=""
                onChange={this.updateFormState}
                validators={[getLengthValidator(1, 100)]}
                isValidCallback={this.setIsValid}
                labelText={t('chainNameLabel')}
                labelTextStyle={inputLabelStyle}
              />

              <CBInputField
                name="business_id"
                inputStyle={{ ...inputStyle, opacity: 0.6, cursor: 'not-allowed' }}
                value={formData.business_id}
                placeholder=""
                onChange={this.updateFormState}
                validators={[getLengthValidator(9, 9)]}
                isValidCallback={this.setIsValid}
                labelText={t('businessIdLabel')}
                labelTextStyle={inputLabelStyle}
                disabled
              />
              <p style={getStyle(screenSize, styles, 'hintText')}>{t('businessIdHint')}</p>

              <CBInputField
                name="street_address"
                inputStyle={inputStyle}
                value={formData.street_address}
                placeholder=""
                onChange={this.updateFormState}
                validators={[]}
                isValidCallback={this.setIsValid}
                labelText={t('addressLabel')}
                labelTextStyle={inputLabelStyle}
              />

              <div style={getStyle(screenSize, styles, 'rowContainer')}>
                <div style={{ flex: 1 }}>
                  <CBInputField
                    name="zip_code"
                    inputStyle={inputStyle}
                    value={formData.zip_code}
                    placeholder=""
                    onChange={this.updateFormState}
                    validators={[]}
                    isValidCallback={this.setIsValid}
                    labelText={t('zipCodeLabel')}
                    labelTextStyle={inputLabelStyle}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <CBInputField
                    name="city"
                    inputStyle={inputStyle}
                    value={formData.city}
                    placeholder=""
                    onChange={this.updateFormState}
                    validators={[]}
                    isValidCallback={this.setIsValid}
                    labelText={t('cityLabel')}
                    labelTextStyle={inputLabelStyle}
                  />
                </div>
              </div>

              <CBInputField
                name="phone_number"
                inputStyle={inputStyle}
                value={formData.phone_number}
                placeholder=""
                onChange={this.updateFormState}
                validators={[]}
                isValidCallback={this.setIsValid}
                labelText={t('phoneLabel')}
                labelTextStyle={inputLabelStyle}
              />

              <CBInputField
                name="email"
                inputStyle={inputStyle}
                value={formData.email}
                placeholder=""
                type="email"
                onChange={this.updateFormState}
                validators={[]}
                isValidCallback={this.setIsValid}
                labelText={t('emailLabel')}
                labelTextStyle={inputLabelStyle}
              />

              <div style={getStyle(screenSize, styles, 'buttonContainer')}>
                <Button
                  onClick={this.submitForm}
                  label={t('saveChanges')}
                  disabled={isLoading || !hasChanges || !canEdit}
                  style={{
                    backgroundColor: hasChanges ? T.accent : 'rgba(255,255,255,0.1)',
                    border: 'none',
                    color: hasChanges ? '#0077b0' : T.textMuted,
                    fontWeight: 600,
                    opacity: (!hasChanges || isLoading) ? 0.5 : 1,
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    card: {
      ...cardStyle,
      position: 'relative',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      marginBottom: 28,
    },
    iconBox: {
      width: 48,
      height: 48,
      borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    title: {
      color: T.textPrimary,
      fontSize: 18,
      fontWeight: 600,
      margin: 0,
    },
    description: {
      color: T.textSecondary,
      fontSize: 13,
      margin: '4px 0 0 0',
    },
    formContainer: {
      maxWidth: '100%',
    },
    rowContainer: {
      display: 'flex',
      gap: 16,
    },
    hintText: {
      color: T.textMuted,
      fontSize: 12,
      margin: '-4px 0 8px 0',
      fontStyle: 'italic',
    },
    buttonContainer: {
      marginTop: 28,
    },
  },
  medium: {
    card: {
      ...cardStyle,
      padding: 16,
    },
    formContainer: {
      maxWidth: '100%',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    chainStatus: state.chain.chainStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    updateChain: _updateChain,
  },
)(translate('ChainSettingsView')(SettingsChainInfoV2));
